import React from 'react';
/* ============================================================
   BOOKER — Componentes de UI compartilhados
   ============================================================ */
var { useState, useEffect, useRef, useMemo } = React;

/* ---------- Ícones (stroke, 24x24) ---------- */
const PATHS = {
  dashboard: 'M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z',
  contratos: 'M8 4h9a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V7M8 4l-3 3M9 12h6M9 16h4M9 8h2',
  alertas: 'M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9M13.7 21a2 2 0 0 1-3.4 0',
  upload: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12',
  search: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16zM21 21l-4.3-4.3',
  sun: 'M12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10zM12 1v2M12 21v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M1 12h2M21 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4',
  moon: 'M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z',
  chevronD: 'M6 9l6 6 6-6',
  chevronR: 'M9 6l6 6-6 6',
  filter: 'M22 3H2l8 9.5V19l4 2v-8.5L22 3z',
  calendar: 'M8 2v4M16 2v4M3 10h18M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z',
  download: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3',
  refresh: 'M3 12a9 9 0 0 1 15-6.7L21 8M21 3v5h-5M21 12a9 9 0 0 1-15 6.7L3 16M3 21v-5h5',
  plus: 'M12 5v14M5 12h14',
  check: 'M20 6L9 17l-5-5',
  x: 'M18 6L6 18M6 6l12 12',
  arrowUp: 'M12 19V5M5 12l7-7 7 7',
  arrowDown: 'M12 5v14M5 12l7 7 7-7',
  building: 'M3 21h18M5 21V7l8-4v18M19 21V11l-6-4M9 9v.01M9 12v.01M9 15v.01M9 18v.01',
  clock: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zM12 6v6l4 2',
  brain: 'M12 5a3 3 0 0 0-5.9.6A3 3 0 0 0 3 9a3 3 0 0 0 1.5 5.2A3 3 0 0 0 9 19a3 3 0 0 0 3-1M12 5a3 3 0 0 1 5.9.6A3 3 0 0 1 21 9a3 3 0 0 1-1.5 5.2A3 3 0 0 1 15 19a3 3 0 0 1-3-1M12 5v14',
  file: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM14 2v6h6',
  sparkles: 'M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9L12 3zM19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8L19 15z',
  trend: 'M3 17l6-6 4 4 8-8M21 7v6h-6',
  user: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z',
  settings: 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z',
  bell: 'M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9M13.7 21a2 2 0 0 1-3.4 0',
  doc: 'M9 12h6M9 16h6M9 8h2M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6zM14 2v6h6',
  external: 'M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6M15 3h6v6M10 14L21 3',
  link: 'M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1',
  dollar: 'M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6',
  alert: 'M12 9v4M12 17h.01M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z',
  info: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20zM12 16v-4M12 8h.01',
  more: 'M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM19 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2z',
  folder: 'M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z',
  edit: 'M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7M18.5 2.5a2.12 2.12 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z',
  trash: 'M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6',
  mail: 'M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zM22 7l-10 6L2 7',
  eye: 'M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7zM12 9.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z',
  copy: 'M9 9h11a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2zM5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1',
  send: 'M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z',
  print: 'M6 9V2h12v7M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2M6 14h12v8H6v-8z',
};
function Icon({ name, size = 20, className = '', style = {}, fill = false }) {
  const d = PATHS[name] || '';
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={fill ? 'currentColor' : 'none'}
      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      className={className} style={{ flexShrink: 0, ...style }} aria-hidden="true">
      {d.split('M').filter(Boolean).map((seg, i) => <path key={i} d={'M' + seg} />)}
    </svg>
  );
}

/* ---------- Logo ---------- */
function Logo({ theme, h = 30 }) {
  return <img src={theme === 'dark' ? 'assets/logo_booker_dark.png' : 'assets/logo_booker_light.png'}
    alt="Booker" style={{ height: h, width: 'auto', display: 'block' }} draggable="false" />;
}

/* ---------- Botões ---------- */
function Button({ children, variant = 'default', size = 'md', icon, iconRight, onClick, style = {}, title }) {
  const base = {
    display: 'inline-flex', alignItems: 'center', gap: 8, fontWeight: 600,
    borderRadius: 'var(--r-sm)', border: '1px solid transparent', whiteSpace: 'nowrap',
    transition: 'all .16s ease', lineHeight: 1,
    padding: size === 'sm' ? '7px 12px' : size === 'lg' ? '13px 22px' : '10px 16px',
    fontSize: size === 'sm' ? 13 : size === 'lg' ? 15 : 14,
  };
  const variants = {
    primary: { background: 'var(--primary-btn)', color: 'var(--primary-btn-text, #fff)', boxShadow: 'var(--shadow-sm)' },
    accent: { background: 'var(--booker-yellow)', color: '#2A2A2C', boxShadow: 'var(--shadow-sm)' },
    default: { background: 'var(--surface)', color: 'var(--text-strong)', borderColor: 'var(--border-strong)' },
    ghost: { background: 'transparent', color: 'var(--text)' },
    danger: { background: 'var(--danger-bg)', color: 'var(--danger)', borderColor: 'transparent' },
  };
  const [hov, setHov] = useState(false);
  const isDark = document.documentElement.getAttribute('data-theme') === 'dark';
  const primaryText = isDark ? '#2A2A2C' : '#fff';
  const v = { ...variants[variant] };
  if (variant === 'primary') v.color = primaryText;
  return (
    <button title={title} onClick={onClick} onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      style={{ ...base, ...v, ...(hov ? { filter: 'brightness(.96)', transform: 'translateY(-1px)' } : {}), ...style }}>
      {icon && <Icon name={icon} size={size === 'sm' ? 15 : 17} />}
      {children}
      {iconRight && <Icon name={iconRight} size={size === 'sm' ? 15 : 17} />}
    </button>
  );
}

/* ---------- Status pill ---------- */
const STATUS_MAP = {
  Ativo: { bg: 'var(--ok-bg)', fg: 'var(--ok)' },
  Vencido: { bg: 'var(--danger-bg)', fg: 'var(--danger)' },
  Inativo: { bg: 'var(--surface-inset)', fg: 'var(--text-muted)' },
  Encerrado: { bg: 'var(--surface-inset)', fg: 'var(--text-muted)' },
  'A vencer': { bg: 'var(--warn-bg)', fg: 'var(--warn)' },
  'A renovar': { bg: 'var(--warn-bg)', fg: 'var(--warn)' },
  Pendente: { bg: 'var(--pending-bg)', fg: 'var(--pending-text)' },
};
function StatusPill({ status, dot = true }) {
  const s = STATUS_MAP[status] || STATUS_MAP.Inativo;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '4px 10px', borderRadius: 99,
      background: s.bg, color: s.fg, fontSize: 12.5, fontWeight: 700, letterSpacing: '.01em' }}>
      {dot && <span style={{ width: 6, height: 6, borderRadius: 99, background: 'currentColor' }} />}
      {status}
    </span>
  );
}

/* ---------- Card ---------- */
function Card({ children, style = {}, pad = 22, hover = false, onClick, className = '' }) {
  const [h, setH] = useState(false);
  return (
    <div className={className} onClick={onClick}
      onMouseEnter={() => hover && setH(true)} onMouseLeave={() => hover && setH(false)}
      style={{
        background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--r-lg)',
        padding: pad, boxShadow: h ? 'var(--shadow)' : 'var(--shadow-sm)',
        transition: 'box-shadow .18s ease, transform .18s ease, border-color .18s',
        transform: h ? 'translateY(-2px)' : 'none', cursor: onClick ? 'pointer' : 'default',
        borderColor: h ? 'var(--border-strong)' : 'var(--border)', ...style,
      }}>
      {children}
    </div>
  );
}

/* ---------- Avatar (iniciais) ---------- */
function Avatar({ name, size = 36, color }) {
  const initials = name.split(' ').filter(w => w.length > 2).slice(0, 2).map(w => w[0]).join('').toUpperCase();
  const palette = ['#E59230', '#3F6FD6', '#1F9D5B', '#9B59B6', '#D6453E', '#0E9DA8'];
  const c = color || palette[name.charCodeAt(0) % palette.length];
  return (
    <span style={{ width: size, height: size, borderRadius: 10, background: c + '22', color: c,
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800,
      fontSize: size * 0.36, flexShrink: 0 }}>{initials}</span>
  );
}

/* ---------- Mini gráfico de barras ---------- */
function BarMini({ data, color = 'var(--booker-orange)', height = 56, labels }) {
  const max = Math.max(...data.map(Math.abs), 1);
  return (
    <div style={{ display: 'flex', alignItems: 'flex-end', gap: 6, height }}>
      {data.map((v, i) => (
        <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, height: '100%', justifyContent: 'flex-end' }}>
          <div style={{ width: '100%', height: Math.max(4, (Math.abs(v) / max) * (height - 18)), background: v < 0 ? 'var(--danger)' : color,
            borderRadius: 5, transformOrigin: 'bottom', animation: `growBar .5s ${i * 0.05}s ease both`, opacity: .9 }} />
          {labels && <span style={{ fontSize: 9.5, color: 'var(--text-faint)', fontWeight: 600 }}>{labels[i]}</span>}
        </div>
      ))}
    </div>
  );
}

/* ---------- Donut ---------- */
function Donut({ segments, size = 132, stroke = 16, center }) {
  const r = (size - stroke) / 2, circ = 2 * Math.PI * r;
  const total = segments.reduce((s, x) => s + x.value, 0) || 1;
  let offset = 0;
  return (
    <div style={{ position: 'relative', width: size, height: size }}>
      <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="var(--surface-inset)" strokeWidth={stroke} />
        {segments.map((s, i) => {
          const len = (s.value / total) * circ;
          const el = <circle key={i} cx={size / 2} cy={size / 2} r={r} fill="none" stroke={s.color}
            strokeWidth={stroke} strokeDasharray={`${len} ${circ - len}`} strokeDashoffset={-offset}
            strokeLinecap="round" style={{ transition: 'stroke-dasharray .6s ease' }} />;
          offset += len; return el;
        })}
      </svg>
      {center && <div style={{ position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>{center}</div>}
    </div>
  );
}

/* ---------- Tabs ---------- */
function Tabs({ tabs, active, onChange }) {
  return (
    <div style={{ display: 'flex', gap: 4, background: 'var(--surface-inset)', padding: 4, borderRadius: 'var(--r)', width: 'fit-content' }}>
      {tabs.map(t => (
        <button key={t.id} onClick={() => onChange(t.id)}
          style={{ padding: '8px 16px', borderRadius: 'var(--r-sm)', border: 'none', fontWeight: 600, fontSize: 13.5,
            background: active === t.id ? 'var(--surface)' : 'transparent',
            color: active === t.id ? 'var(--text-strong)' : 'var(--text-muted)',
            boxShadow: active === t.id ? 'var(--shadow-sm)' : 'none', transition: 'all .15s' }}>
          {t.label}
        </button>
      ))}
    </div>
  );
}

/* ---------- Indice badge ---------- */
function IndiceBadge({ k, sub }) {
  const idx = window.DB.INDICES[k];
  if (!idx) return null;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontWeight: 700, fontSize: 12.5, color: idx.color, whiteSpace: 'nowrap' }}>
      <span style={{ width: 8, height: 8, borderRadius: 2, background: idx.color }} />
      {idx.label}{sub && <span style={{ color: 'var(--text-faint)', fontWeight: 500 }}>· {sub}</span>}
    </span>
  );
}

Object.assign(window, { Icon, Logo, Button, StatusPill, Card, Avatar, BarMini, Donut, Tabs, IndiceBadge, STATUS_MAP });
